import { initializeChakraComponent } from 'Shared/chakra-initialize';
import Header from './header';
import { initializeNotificationsService } from 'Shared/Notifications/notification_service';
import { withBreakpointsContext } from 'Shared/utils/breakpoints';

initializeNotificationsService();

initializeChakraComponent('Header', withBreakpointsContext(Header));
